/**
 * Etichetta dell'utente che ha creato un evento in timeline.
 * Preferisce il nome completo, ripiega sulla parte locale dell'email.
 * Gli eventi senza autore (import/webhook) sono marcati come "Sistema".
 */
export interface EventAuthor {
    full_name: string | null;
    email: string;
}

export const SYSTEM_AUTHOR_LABEL = 'Sistema';

export function formatEventAuthor(creator?: EventAuthor | null): string {
    if (!creator) return SYSTEM_AUTHOR_LABEL;

    const fullName = creator.full_name?.trim();
    if (fullName) return fullName;

    return creator.email?.split('@')[0] || SYSTEM_AUTHOR_LABEL;
}
